import React from 'react'

const ToggleBtn = ({ state, onClickFunction, title }) => {
    return (
        <div className='flex gap-3 items-center'>
            <button className={`matchCornerButton ${state ? 'on' : 'off'}`} onClick={(e) => onClickFunction?.(e)}>
                <span className="pin" />
            </button>
            {title && <label htmlFor="range" className='text-sm text-[var(--secondary-text)]'>{title}</label>}
        </div>
    )
}

export default ToggleBtn